import React, {useState} from "react";
import "../styles/Services.css";

const Services = () => {

    const services = [
        {
            title: "Data Strategy and Insights",
            description:
                "We transform raw data into actionable insights to guide informed decision-making and drive strategic growth.",
            capabilities: ["Data Analysis", "Data Visualization", "Statistical Modeling", "KPI Development"],
        },
        {
            title: "Web Development and Applications",
            description:
                "We design and develop responsive, user-friendly websites and web applications tailored to your business needs.",
            capabilities: ["Front-End Development", "React Applications", "UI/UX Optimization", "Web Analytics"],
        },
        {
            title: "Machine Learning Solutions",
            description:
                "We build custom machine learning models to automate processes, forecast trends, and uncover patterns.",
            capabilities: ["Supervised Learning", "Unsupervised Learning", "Predictive Analytics", "Model Optimization"],
        },
        {
            title: "Deep Learning and AI",
            description:
                "Harness the power of deep learning to solve complex challenges and unlock transformative opportunities.",
            capabilities: ["Computer Vision", "Natural Language Processing (NLP)", "AI Model Deployment", "Neural Networks"],
        },
        {
            title: "Dashboard and Reporting Solutions",
            description:
                "We create intuitive dashboards that provide real-time insights and enhance data-driven decision-making.",
            capabilities: ["JavaScript Dashboards", "Power BI Reporting", "Interactive Visualizations", "Data Integration"],
        },
        {
            title: "Program Evaluation and Impact Analysis",
            description:
                "We help you assess program performance and measure impact to ensure alignment with your strategic goals.",
            capabilities: ["Logic Model Development", "Outcome Assessment", "Impact Reporting", "Stakeholder Analysis"],
        },
        {
            title: "Risk and Revenue Management",
            description:
                "We enable businesses to identify risks and optimize revenue streams through robust data analysis.",
            capabilities: ["Risk Assessment", "Revenue Forecasting", "Pricing Models", "Scenario Analysis"],
        },
        {
            title: "Data Engineering and Infrastructure",
            description:
                "We design and implement scalable data pipelines and systems to support your analytics and machine learning needs.",
            capabilities: ["ETL Development", "Cloud Data Solutions", "Database Optimization", "Data Pipeline Automation"],
        },
        {
            title: "Business Intelligence and Analytics",
            description:
                "We empower organizations with advanced analytics tools to unlock hidden opportunities and optimize operations.",
            capabilities: ["Power BI Dashboards", "Advanced SQL Queries", "Data Warehousing", "Forecasting Models"],
        },
        {
            title: "Natural Language Processing (NLP) Applications",
            description:
                "We develop NLP solutions to analyze and interpret textual data for enhanced customer insights and automation.",
            capabilities: ["Text Analytics", "Chatbots and Conversational AI", "Sentiment Analysis", "Document Processing"],
        },
        {
            title: "Custom AI-Powered Solutions",
            description:
                "We deliver tailored AI solutions that integrate seamlessly into your business processes to drive innovation.",
            capabilities: ["AI Model Development", "Automation Workflows", "AI Strategy Consulting", "AI Deployment"],
        },
        {
            title: "Computer Vision and Image Analysis",
            description:
                "We provide image recognition and analysis solutions to tackle visual data challenges across industries.",
            capabilities: ["Object Detection", "Image Classification", "Facial Recognition", "Video Analytics"],
        },
    ];


    const [expandedService, setExpandedService] = useState(null);

    const toggleCapabilities = (index) => {
        setExpandedService(expandedService === index ? null : index);
    };
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="services-page">
            {/* Hero Section */}
            <div className={"services-big"}>
                <div className="services-hero">
                    <div className="services-hero-text">
                        <h1>We turn uncertainty into clarity.</h1>
                    </div>
                    <div className="services-hero-curve">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1000 200"
                            preserveAspectRatio="none"
                            className="animated-curve"
                        >
                            <path
                                d="M0,100 Q250,-50 500,100 T1000,100"
                                stroke="url(#gradient)"
                                fill="none"
                                strokeWidth="4"
                            />
                            <defs>
                                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" stopColor="#152238" />
                                    <stop offset="100%" stopColor="#EE4266" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </div>

                <div className={"services-list-container"}>

                    <div className="services-list">
                        {services.map((service, index) => (
                            <div key={index} className="service-item">
                                {/* Service Content */}
                                <div className="service-content">
                                    <h3 className="service-title">
                                        {service.title}{" "}
                                        <span
                                            className={`arrow ${
                                                expandedService === index ? "expanded" : ""
                                            }`}
                                            onClick={() => toggleCapabilities(index)}
                                        >
                                        →
                                    </span>
                                    </h3>
                                    <p className="service-description">{service.description}</p>
                                    {expandedService === index && (
                                        <div
                                            className={`capabilities ${expandedService === index ? "expanded" : ""}`}
                                        >
                                            <ul>
                                                {service.capabilities.map((capability, capIndex) => (
                                                    <li key={capIndex}>{capability}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>



                </div>
            </div>
        </div>
    );
};

export default Services;
